import { render } from "./oos-alternatives.vue?vue&type=template&id=6aa9a666"
import script from "./oos-alternatives.vue?vue&type=script&lang=js"
export * from "./oos-alternatives.vue?vue&type=script&lang=js"

import "./oos-alternatives.vue?vue&type=style&index=0&id=6aa9a666&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__